import { RouteNames } from '$app/router'

import useReturnToInfo from './useReturnToInfo'

/**
 * Redirect target to whatever current URL's `return_to` query parameter.
 */
export const useReturnToTarget = (fallback: RouteNames) => {
  const { return_to, isValid } = useReturnToInfo()

  const destination = return_to || fallback

  // Only redirect to valid route-names
  // otherwise, use fallback
  const target = isValid ? destination : fallback

  return target
}

export default useReturnToTarget
